import React, { useEffect, useState } from 'react'
import ScannerWrap from '../../../scanner/ScannerWrap'
import MySpiner from '../../../UI/spiner/MySpiner'
import GoodSelectReadNew from './fields/GoodSelectReadNew'

const ReadNewSeries = ({ goodDataMain, goodData, setGoodData, reset, setReset }) => {

    const [scanResultTemp, setScanResultTemp] = useState('')

    useEffect(() => {
        if (reset) { // Якщо треба скинути
            setScanResultTemp('')
        }
    }, [reset])

  return (
    <div className='seriesRead'>
        <h4>2. Зчитати QR-код нового товару в коробці</h4>

        {
            goodDataMain && goodDataMain.seriesesInBoxWithoutSeriesOptions && goodDataMain.seriesesInBoxWithoutSeriesOptions.length > 0 ?
                <>
                    <ScannerWrap
                        setResultText={setScanResultTemp}
                        reset={reset}
                        setReset={setReset}
                    />

                    {
                        scanResultTemp ? 
                            <div className='success'>
                                Результат сканування: {scanResultTemp}
                            </div>
                        : ''
                    }

                    {
                        scanResultTemp ?
                            <>
                                <p>Оберіть товар, що буде доданий в коробку зі списку доступних нижче:</p>
                                <GoodSelectReadNew
                                    options={goodDataMain ? goodDataMain.seriesesInBoxWithoutSeriesOptions : []}
                                    required={false}
                                    setValidate={e => {}}
                                    setValueForm={e => {
                                        setGoodData({
                                            series: scanResultTemp,
                                            // goodId: e,
                                            seriesId: e,
                                            // seriesId: getSeriesIdFromOptions(e)
                                        })
                                    }}
                                    forciblyValue={''}
                                />
                            </>
                        : ''
                    }
                </>
            : 
                <div className='error'>
                    Немає доступних товарів в коробці без серії для додавання нового. Зверніться до адміністратора
                </div>
        }

    </div>
  )
}

export default ReadNewSeries